import React from "react";
import Slide from "../../utils/images/slide-1.jpg";
import colors from "../../utils/colors";
import styled from "styled-components";
const Layout = styled.div`
  .text {
    font-family: "Oswald" sans-serif;
    font-size: 40;
    font-weight: 700;
    margin-bottom: 24;
    color: white;
    text-align: center;
  }
`;
function Banner() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <h3 className="text">AT TRANSCORP HILTON HOTEL ABUJA</h3>
          <span style={styles.btn}>GET DIRECTION</span>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `linear-gradient(0deg,rgba(125,50,210,0.5),rgba(200,170,110,0.5)),url(${Slide})`,
    height: 470,
    backgroundSize: "cover",
    zIndex: 3,
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "white",
  },
  text: {
    fontSize: 40,
    fontWeight: 700,
    marginBottom: 24,
    color: "white",
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
  btn: {
    fontSize: 17,
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "20px 0px 0px",
    backgroundColor: "transparent",
    padding: "10px 50px",
    color: colors.white,
    border: "1px solid #fff",
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
  heart: {
    marginBottom: 14,
  },
  proposeText: {
    fontSize: 39,
    fontFamily: "sans-serif",
    color: colors.white,
    fontWeight: "bold",
  },
};

export default Banner;
